import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function getVersiKategoriSE(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/versikategorise`, body, config);
  return data;
}

export async function updateKategoriSEData(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.put(`${apiUrl}/kategorise/update`, body, config);
  return data;
}

export async function signDocument(formData) {
  config.headers = { 'Content-Type': 'multipart/form-data', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/kategorise/sign`, formData, config);
  return data;
}

export async function signUpload(formData) {
  config.headers = { 'Content-Type': 'multipart/form-data', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/kategorise/signupload`, formData, config);
  return data;
}
